import './spacer.scss';

export default function Spacer(){
    return (
        <div className="spacer"></div>
    )
}